import { render, staticRenderFns } from "./OrderReferenceNumbers.vue?vue&type=template&id=03df5759"
import script from "./OrderReferenceNumbers.vue?vue&type=script&lang=ts"
export * from "./OrderReferenceNumbers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports